//External
import React from "react";
// import { useFormik } from "formik";
import BookingAddress from "components/bookingSteps/bookingAddress";
import { setDefaultCarImage } from "utils";
/*******************
  @Purpose :  used for car detail info
  @Parameter : {vehicalDetailData }
  @Author : INIC
 *******************/
const CarDetailInfo = ({
  vehicalDetailData,
  days,
  formik,
  stateShortName,
  dropoffStateShortName,
  startDate,
  startTimeDefaultValue,
  endDate,
  endTimeDefaultValue,
  isShowEmailMeQuotaInPriceDetail,
}) => {
  /*******************
  @purpose : Rander HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      {vehicalDetailData && (
        <>
          <div className="d-flex justify-content-between align-items-start booking-heading">
            <div className="d-flex align-items-start booking-brand-icon w-100">
              <h1
                className={`booking-detail-title fx-title pr-2 ${
                  !isShowEmailMeQuotaInPriceDetail ? "title-without-text" : ""
                }`}
              >
                {vehicalDetailData?.name_with_brand}
              </h1>
            </div>
          </div>

          <div className="d-flex align-items-start car-detail-box">
            <div className="car-image reserve-car-image">
              <img
                src={vehicalDetailData?.high_resolution_img}
                alt={vehicalDetailData?.all_images?.[0]?.alt}
                onError={setDefaultCarImage}
              />
            </div>

            <div className="step2-booking">
              {startDate && endDate && (
                <BookingAddress
                  step={1}
                  formik={formik}
                  stateShortName={stateShortName}
                  dropoffStateShortName={dropoffStateShortName}
                  startDate={startDate}
                  startTimeDefaultValue={startTimeDefaultValue}
                  endDate={endDate}
                  endTimeDefaultValue={endTimeDefaultValue}
                  vehicalDetailData={vehicalDetailData}
                  days={days}
                />
              )}
            </div>

            {/* <div className="car-detail-info">
              <div className="d-flex align-items-end breakdown-price">
                <span className="mb-0">
                  <span className="text-dark fw-500 text-big">
                    ${vehicalDetailData?.day}{" "}
                  </span>
                  {vehicalDetailData?.real_price ? (
                    <>
                      <small className="text-dark">
                        <del className="ml-1">
                          ${vehicalDetailData?.real_price}{" "}
                        </del>
                        /day
                      </small>
                    </>
                  ) : (
                    <>
                      <small>per day</small>
                    </>
                  )}
                </span>
              </div>
              <span className="d-block ff-hel-reg">
                {days > 0
                  ? vehicalDetailData?.milesday * days
                  : vehicalDetailData?.milesday}{" "}
                <span className="nm-text">free miles total</span>
              </span>
              <span className="d-block ff-hel-reg">
                ${vehicalDetailData?.extramile} <span className="nm-text">per extra mile</span>
              </span>
            </div> */}
          </div>
        </>
      )}
    </>
  );
};

export default CarDetailInfo;
